import axios from "axios";

import { getToken, logout } from "../auth";

// Axios instance pointed at the standalone Flask backend. Base URL mirrors the
// vasana-web pattern of reading REACT_APP_API_URL from the environment.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5001",
  // The deep-dive endpoint is heavy (~cold seconds until the cache warms), which
  // exceeded the old 30s timeout and aborted the request every time.
  timeout: 120000,
});

// Attach the stored access token to every request (the API verifies it and
// enforces platform_admin). Sent as a bare token to match vasana-be.
api.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) cfg.headers.Authorization = token;
  return cfg;
});

// On 401 (missing/expired/invalid platform token), send the visitor back to the
// platform login. logout() clears the shared cookie and redirects.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      logout();
    }
    return Promise.reject(err);
  }
);

export default api;
